import XLSX from "xlsx";

function ProcessExcelGetFirstSheet(data: string | ArrayBuffer | null) {
  const workbook = XLSX.read(data, {
    type: "binary",
  });
  const firstSheet = workbook.SheetNames[0];
  const dataXLSX = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet], { header: 1 });
  return dataXLSX;
}

export function ReadExcelFile(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    if (file) {
      reader.onload = (e) => {
        const contents = ProcessExcelGetFirstSheet(e.target ? e.target.result : null);
        resolve({
          fileName: file.name,
          fileType: file.type,
          raw: e.target ? e.target.result : null,
          contents: contents,
        });
      };
      reader.readAsBinaryString(file);
    } else {
      reject("Failed to load file");
    }
  });
}
